import Vue from "vue";
import ContactForm from "./Components/ContactForm.js";

window.Vue = Vue;

Vue.component("contact-form", ContactForm);

new Vue({
    el: "#app"
});